import React, { useState, useRef, useEffect } from 'react';
import {Row, Col, Grid} from "react-flexbox-grid";
import '../../../startproj/mergeform.css';
import { Input } from 'antd';
import Form from 'react-bootstrap/Form'
import Alert from "../../../../components/Alert";
import {confirmAlert} from "react-confirm-alert";
import "../../../startproj/Review/review.css";

function ReqSosOutage({ preEForm, onChangeReqSos, saveVisibleText }) {
  const [sosItems, setSosItems] = useState(
    () => preEForm.reqSos ? preEForm.reqSos.split(',').filter(Boolean) : []
  );
  const [reqValidateMsg, setReqValidateMsg] = useState('');
  const [inputValue, setInputValue] = useState('');
  const prevReqSosRef = useRef(preEForm.reqSos);

  useEffect(() => {
    if (preEForm.reqSos !== prevReqSosRef.current) {
      prevReqSosRef.current = preEForm.reqSos;
      setSosItems(
        preEForm.reqSos ? preEForm.reqSos.split(',').filter(Boolean) : []
      );
    }
  }, [preEForm.reqSos]);

  function updateList(newItems) {
    setSosItems(newItems);
    prevReqSosRef.current = newItems.join(',');
    onChangeReqSos(newItems.join(','));
  }

  function validateReq(e) {
    if (!((e.which >= 48 && e.which <= 57) || e.which === 45))
      e.preventDefault();
    if (e.which === 45 && e.currentTarget.value.length === 2)
      return;
    else if (e.which === 45 && e.currentTarget.value.length !== 2)
      e.preventDefault();
    else if (e.which !== 45 && e.currentTarget.value.length === 2)
      e.preventDefault();
  }

  function removeSelected() {
    const sosBox = document.getElementById('req-sos-list');
    const selectedValues = Array.from(sosBox.options)
      .filter(opt => opt.selected)
      .map(opt => opt.value);

    updateList(sosItems.filter(item => !selectedValues.includes(item)));
  }

  function addSelected() {
    const sosBox = document.getElementById('select-drop-down-reqsos');
    const selectReqValue = sosBox.options[sosBox.selectedIndex].value;
    const trimmedInput = inputValue.trim();

    let msg1 = null;
    let msg2 = null;

    if (selectReqValue) {
      if (sosItems.includes(selectReqValue)) {
        msg1 = `Selected REQ value ${selectReqValue} is already in the list.`;
      }
    }

    if (trimmedInput && trimmedInput !== selectReqValue) {
      if (trimmedInput.length !== 9) {
        msg2 = `Input REQ value ${trimmedInput} does not have the correct format (00-000000).`;
      } else if (sosItems.includes(trimmedInput)) {
        msg2 = `Input REQ value ${trimmedInput} is already in the list.`;
      }
    }

    if (msg1 || msg2) {
      setReqValidateMsg([msg1, msg2].filter(Boolean).join(', '));
      return;
    }

    setReqValidateMsg('');

    const nextItems = [...sosItems];

    if (selectReqValue && !nextItems.includes(selectReqValue)) {
      nextItems.push(selectReqValue);
    }
    if (trimmedInput && trimmedInput !== selectReqValue && trimmedInput.length === 9 && !nextItems.includes(trimmedInput)) {
      nextItems.push(trimmedInput);
    }

    if (nextItems.length !== sosItems.length) {
      updateList(nextItems);
      setInputValue('');
    }
  }

  const getEquipments = (equipList) => {
    if (equipList && equipList.length > 0) {
      if (equipList.length < 4) {
        return (
          <div>
            {equipList.length > 0 ? <div>{equipList[0].equipName}</div> : ''}
            {equipList.length > 1 ? <div>{equipList[1].equipName}</div> : ''}
            {equipList.length > 2 ? <div>{equipList[2].equipName}</div> : ''}
          </div>
        );
      } else {
        return (
          <div>
            <div>{equipList[0].equipName}</div>
            <div>{equipList[1].equipName}</div>
            <div>{equipList[2].equipName}</div>
            <div className='line1' style={{position: 'right'}}>{equipList[3].equipName} ...</div>
            <div className='tooltip' style={{ width: '100%', alignItems: 'right'}}> {getEquipList(equipList)} </div>
          </div>
        );
      }
    } else {
      return (<div></div>);
    }
  }

  const getEquipList = (equipList) => {
    return equipList.map((equip, index) => (
      <div key={index}>{equip.equipName}</div>
    ));
  }

  return (
    <Row controlId='reqSos' style={{marginBottom: 8}}>
      <label className='col-xs-12 col-md-2' style={{ marginTop: 0}}><strong>REQ/SOS #:</strong></label>
      <label className='col-xs-12' mdOffset={3} style={{ marginTop: 0, color: 'red'}}><i>{reqValidateMsg}</i></label>
      <Grid fluid className="container" style={{margin: 10}}>
        <Row>
          <Col md={6}>
            <Row>
              <Col md={6} mdOffset={3} style={{placeContent: 'right'}}>
                <Form.Control as="select" id="select-drop-down-reqsos"
                              disabled={!saveVisibleText}>
                  <option
                    id="reqSOS"
                    key=""
                    value=""
                  >Choose REQ/SOS#</option>
                  {preEForm.reqSOSList && preEForm.reqSOSList.map((req, index) => (
                    <option
                      id="reqSOS"
                      key={req}
                      value={req}
                    >   {req}
                    </option>
                  ))}
                </Form.Control>
              </Col>
              <Col md={2}>
                <button type='button' className='btn btn-primary pull-right'
                        disabled={!saveVisibleText} onClick={() => addSelected()}> Add </button>
              </Col>
            </Row>
            <Row>
              <Col md={6} mdOffset={3}>
                <Input
                  id="reqsos-input"
                  value={inputValue}
                  onChange={e => setInputValue(e.target.value)}
                  maxLength='9'
                  placeholder='Enter REQ/SOS# 00-000000'
                  disabled={!saveVisibleText}
                  onKeyPress={e => validateReq(e)}
                />
              </Col>
            </Row>
          </Col>
          <Col md={4}>
            <Row>
              <Col md={4}>
                <Form.Control as="select" size={5} id="req-sos-list" multiple={true} style={{width: 125}} disabled={!saveVisibleText}>
                  {sosItems.map((sos) => (
                    <option
                      key={sos}
                      value={sos}
                    >   {sos}
                    </option>
                  ))}
                </Form.Control>
              </Col>
              <Col md={2} mdOffset={3}>
                <button type='button' className='btn btn-primary pull-right'
                        disabled={!saveVisibleText} onClick={() => removeSelected()}> Remove </button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Grid>

      <label className='col-xs-12 col-md-2' style={{ marginTop: 10}}><strong>Outage Data:</strong></label>
      <Grid fluid className="container" style={{border:'1px solid grey', marginTop: 10, marginLeft:20, marginRight:20}}>
        {!preEForm.outageRecord &&
          <Row style={{alignItems: 'center'}}>
            <label><strong><i className="fa fa-info-circle" style={{color: 'red', paddingRight: '3px'}}
                               aria-hidden="true">Unable to match Outage Data</i></strong></label>
          </Row>
        }
        <Row>
          <Col className='col-8'>
            <Row style={{marginTop: 10}}>
              <Col className='col-4'>
                <strong>Scheduled Start Date:</strong>
              </Col>
              <Col className='col-5'>
                {preEForm.outageRecord ? preEForm.outageRecord.schedStartDate : ''}
              </Col>
            </Row>
            <Row>
              <Col className='col-4'>
                <strong>Scheduled End Date:</strong>
              </Col>
              <Col className='col-4'>
                {preEForm.outageRecord ? preEForm.outageRecord.schedEndDate : ''}
              </Col>
            </Row>
            <Row>
              <Col className='col-4'>
                <strong>Contact Person:</strong>
              </Col>
              <Col className='col-8'>
                {preEForm.outageRecord ? preEForm.outageRecord.contactPerson.length > 40 ?
                  <div>
                    <div className='line1'>{preEForm.outageRecord.contactPerson.substring(0, 40)}...</div>
                    <div className='tooltip' style={{ width: '100%', alignItems: 'right'}}>
                      {preEForm.outageRecord.contactPerson}
                    </div>
                  </div>
                  : preEForm.outageRecord.contactPerson : ''}
              </Col>
            </Row>
            <Row style={{marginBottom: 10}}>
              <Col className='col-4'>
                <strong>REQ Status:</strong>
              </Col>
              <Col className='col-4'>
                {preEForm.outageRecord ? preEForm.outageRecord.reqStatus : ''}
              </Col>
            </Row>
          </Col>

          <Col className='col-4'>
            <Row style={{alignItems: 'left', marginTop: 10}}>
              <Col className='col-4'>
                <strong>Equipments:</strong>
              </Col>
            </Row>
            <Row>
              <Col className='col-8'>
                {(preEForm.outageRecord && preEForm.outageRecord.outageEquips) ?
                  getEquipments(preEForm.outageRecord.outageEquips)
                  : <div></div>
                }
              </Col>
            </Row>
          </Col>
        </Row>
      </Grid>
    </Row>
  );
}

export default ReqSosOutage;